import ExecutaRest from '../util/ExecutaRest'

class anexosApi {
    static obterAnexosPorAtendimento(idAtendimento){

        var rest = new ExecutaRest();
        return new Promise(function (resolve, reject) {
            rest.Post('AtendimentoSL.svc/rest/ObtemArquivosPorIdAtendimentoREST', idAtendimento).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> obterAnexosPorAtendimento: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

    static anexar(idAtendimento, idHistorico, fileData, visivel) {

        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            rest.PostArquivoAtendimento(idAtendimento, idHistorico, fileData, visivel).then(retorno => {
                
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> anexar: ' + error /*areaTratamento.statusText*/);
            });

        });

    }



}

 export default anexosApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/anexosApi.js
 **/